var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "multi-header mx-3 mx-0-desktop" }, [
      _c(
        "h1",
        { staticClass: "title is-3 is-spaced has-text-centered-touch" },
        [_vm._v(" " + _vm._s(_vm.$t("contact_form.feedback")) + " ")]
      ),
      _c(
        "div",
        [
          !_vm.isAdmin && _vm.isButtonAvailable && _vm.userRatingEnabled
            ? _c(
                "b-button",
                {
                  attrs: { type: "is-primary" },
                  on: {
                    click: function ($event) {
                      return _vm.rateUs()
                    },
                  },
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "star" },
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("contact_form.rateUs")) + " "),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "tile is-ancestor" }, [
      _c("div", { staticClass: "tile is-vertical" }, [
        _c(
          "div",
          { staticClass: "tile is-parent" },
          [_c("FeedbackForm", { staticClass: "tile is-child box" })],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }